module.exports = __webpack_public_path__ + "static/img/img-cadastro.7c41c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-cadastro.png
// module id = 696
// module chunks = 5